(function () {
  // Newsletter-Link schaltet ein Gratisprodukt frei: Aktionscode setzen, falls noch kein Produktcode im
  // Warenkorb liegt (ein Influencer-Code bleibt und gilt fürs Gratisprodukt), dann das Aktions-Token an
  // die vorhandenen Rabatt-Tokens anhängen. Code, Token und URL-Parameter kommen als data-Attribute aus
  // den Markt-Metafeldern (snippets/gift-action.liquid).
  const scriptEl = document.currentScript || document.querySelector('script[src*="gift-action"]');

  function readAttribute(name) {
    const value = scriptEl && scriptEl.getAttribute(name);
    return value ? value.trim() : '';
  }

  const CODE = readAttribute('data-code');
  // co2 schreibt Tokens kleingeschrieben, also auch so vergleichen.
  const TOKEN = readAttribute('data-token').toLowerCase();
  const PARAM = readAttribute('data-param');
  // Der Versanddienst hängt eigene Parameter an und verschluckt dabei in manchen Links den
  // konfigurierten Parameter, während die UTM-Parameter überleben. Deshalb löst genau diese eine
  // Kampagne zusätzlich aus — exakter Vergleich, damit kein anderer Versand mitgreift.
  const UTM_CAMPAIGN = '20260918_SupportNL_DE_AT_CreatineSticksJar_0200PM';

  if (!CODE || !TOKEN || !PARAM) return;
  const search = new URLSearchParams(window.location.search);
  if (!search.has(PARAM) && search.get('utm_campaign') !== UTM_CAMPAIGN) return;
  if (typeof co2 === 'undefined') return;

  // Vor dem Event kein co2-Aufruf: init() greift synchron auf window.client zu, den erst das später
  // geladene Vite-Bundle anlegt. Das Event feuert nach jedem cartInit, also auch nach unseren eigenen
  // Warenkorb-Updates — deshalb once.
  window.addEventListener('co2.cart.initialized', unlock, { once: true });

  function publishCartUpdate() {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'global', cartData: null });
  }

  async function unlock() {
    let wrote = false;
    let unlocked = false;

    try {
      let codeOk = true;
      const existingCode = await co2.getProductLevelCode();
      if (!existingCode) {
        wrote = true;
        const outcome = await co2.addDiscountCode(CODE);
        codeOk = !!outcome && outcome.ok === true;
        if (!codeOk) {
          console.warn('[gift-action] Aktionscode nicht übernommen:', CODE, outcome);
        }
      }

      // setDiscountTokens ersetzt die Liste komplett, vorhandene Tokens müssen mit. Ein aufgelöster
      // Aufruf ist noch keine Bestätigung: false heißt abgelehnt, sonst zählt nur, was danach wirklich
      // in der Liste steht.
      const current = await co2.getDiscountTokens();
      const tokens = Array.isArray(current) ? current : [];
      let tokenOk = tokens.includes(TOKEN);
      if (!tokenOk) {
        const result = await co2.setDiscountTokens(tokens.concat(TOKEN));
        if (result === false) {
          console.warn('[gift-action] Token abgelehnt:', TOKEN);
        } else {
          wrote = true;
          const after = await co2.getDiscountTokens();
          tokenOk = Array.isArray(after) && after.includes(TOKEN);
          if (!tokenOk) {
            console.warn('[gift-action] Token nach dem Schreiben nicht gesetzt:', TOKEN);
          }
        }
      }

      unlocked = codeOk && tokenOk;
    } catch (error) {
      console.warn('[gift-action] Freischaltung fehlgeschlagen:', error);
    }

    if (wrote) {
      publishCartUpdate();
    }

    // Nur nach vollem Erfolg; sonst bleibt der Parameter für einen erneuten Versuch beim Neuladen.
    if (unlocked) {
      const url = new URL(window.location.href);
      url.searchParams.delete(PARAM);
      history.replaceState(history.state, '', url);
    }
  }
})();
